import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { AuthenticationService } from '@app/services/authentication.service';
import { ModalResult, ModalPublicProperties, SmsLoginModalComponent as ModalComponent } from './sms-login-modal.component';

@Injectable({ providedIn: 'root' })
export class SmsLoginModalService {
  constructor(private modalService: ModalService, private authenticationService: AuthenticationService) {}

  open(properties?: ModalPublicProperties, options: NgbModalOptions & { beforeDismiss?: never } = {}) {
    if (this.authenticationService.isMissingTwoStep()) {
      (options as NgbModalOptions).beforeDismiss = () => {
        this.authenticationService.logout().subscribe(); // Forces logout if the modal is dismissed to avoid partial login
        return true;
      };
    }

    return this.modalService.open<ModalResult>(ModalComponent, properties, options);
  }
}
